<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <input-field
          name="wide_wine-keyServer"
          label="Key Server*"
          label-position="top"
        >
          <div
            v-clipboard:copy="settings.keyServerUrl"
            v-clipboard:success="copySuccess"
            class="text-wrap w-100 link cursor-pointer"
          >
            {{ settings.keyServerUrl || '-' }}
            <GjIcon
              v-if="settings.keyServerUrl"
              name="Copy"
              size="20"
            />
          </div>
        </input-field>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <input-field
          name="wide_wine-signer"
          label="Signer*"
          label-position="top"
        >
          <div>
            {{ settings.signer }}
          </div>
        </input-field>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <input-field
          name="wide_wine-aesSigningKey"
          label="AES Signing Key"
          label-position="top"
        >
          <div
            v-clipboard:copy="settings.aesSigningKey"
            v-clipboard:success="copySuccess"
            class="text-wrap w-100 link cursor-pointer"
          >
            {{ settings.aesSigningKey || '-' }}
            <GjIcon
              v-if="settings.aesSigningKey"
              name="Copy"
              size="20"
            />
          </div>
        </input-field>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <input-field
          v-clipboard:copy="settings.aesSigningIV"
          v-clipboard:success="copySuccess"
          name="wide_wine-aesSigningIV"
          label="AES Signing IV"
          label-position="top"
          class="link cursor-pointer"
        >
          <div class="text-wrap w-100">
            {{ settings.aesSigningIV || '-' }}
            <GjIcon
              v-if="settings.aesSigningIV"
              name="Copy"
              size="20"
            />
          </div>
        </input-field>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <input-field
          name="wide_wine-rsaSigningKeyPath"
          label="RSA Signing Key Path"
          label-position="top"
        >
          <div class="text-wrap link cursor-pointer w-100">
            {{ settings.rsaSigningKeyPath || '-' }}
            <GjIcon
              v-if="settings.rsaSigningKeyPath"
              name="Copy"
              size="20"
            />
          </div>
        </input-field>
      </b-col>
      <b-col />
    </b-row>
  </div>
</template>
<script>
import InputField from '@/components/form/InputField.vue'

export default {
  name: 'WideVine',
  components: {
    InputField,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
}
</script>
